import lockr from 'lockr';

export default function configureLockr() {
  lockr.prefix = 'ufsdn_';
}
